module.exports = __webpack_public_path__ + "img/search.20450d0b.svg";